import i18n from 'i18next'
import _ from 'lodash'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

const languageDetector = new LanguageDetector(null, {
  order: ['localStorage', 'navigator'],
  caches: ['localStorage'],
})


function getLanguageCode(i18nObject) {
  const locales = Object.keys(_.get(i18nObject, ['store', 'data'], {}))

  return (
    i18nObject.languages &&
    i18nObject.languages.find(lng => locales.includes(lng))
  )
}

async function getActiveLanguage() {
  if (!i18n.isInitialized) {
    await new Promise(resolve => i18n.on('initialized', resolve))
  }

  return getLanguageCode(i18n)
}

async function getMetabaseLanguage() {
  if (!i18n.isInitialized) {
    await new Promise(resolve => i18n.on('initialized', resolve))
  }

  return window.MetabaseUserLocalization?.headers?.language || 'en'
}

async function fetchTranslationURL(lng) {
  try {
    const response = await fetch('api/custom-env')
    const envVariable = await response.json()

    const isOnPremise = envVariable?.IS_ON_PREMISE === "true";
    let translationUrl;
    if (isOnPremise) {
      translationUrl = `http://${window.location.hostname}:${envVariable?.QURE_TRANSLATIONS_PORT}/${envVariable?.QURE_TRANSLATIONS_PROJECT}/${lng}.json`;
    } else {
      translationUrl = `${envVariable?.QURE_TRANSLATIONS_HOST}/${envVariable?.QURE_TRANSLATIONS_PROJECT}/${lng}.json`;
    }
    console.log("Loaded i18 Configuration")
    return translationUrl
  } catch (error) {
    console.error('Error fetching translation URL:', error)
  }
}

const options = {
  load: 'languageOnly',
  order: ['localStorage', 'navigator'],
  caches: ['localStorage'],
  lng: (window.MetabaseUserLocalization?.headers?.language || 'en'),
  fallbackLng: 'en',
  debug: false,
  keySeparator: '.',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  backend: {
    loadPath: async function (lng) {
      return await fetchTranslationURL(lng)
    },
    crossDomain: true,
  },
}

// Initialize i18n with all necessary plugins
i18n
  .use(Backend)
  .use(languageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init(options)

export { i18n as default, getActiveLanguage, getLanguageCode }






